import { AlertBanner } from '@latitude/alert-banner';

type DefaultErrorFallbackProps = {
  error: Error;
  resetErrorBoundary?: () => void;
  /** Override the default "Something went wrong" title */
  title?: string;
};

export function DefaultErrorFallback({
  error,
  resetErrorBoundary,
  title = 'Something went wrong',
}: DefaultErrorFallbackProps) {
  return (
    <AlertBanner
      variant="error"
      title={title}
      description="An unexpected error occurred. Please try again."
      detailsText={error.message}
      buttonLabel={resetErrorBoundary ? 'Retry' : undefined}
      onActionClick={resetErrorBoundary}
      data-testid="error-boundary-fallback"
    />
  );
}
